<template>
  <div>
    <b-card-body>
      <b-card class="exportContainer">
        <b-form submit.stop.prevent="saveXML">
          <!-- <p><b>Simulador - Configuração de comunicação</b></p>
          <BR /> -->
          <b-row>
            <b-col sm="12">
              <div>
                <p>{{$t('exportScenarioMessage')}}</p>
                <!-- <b-button @click="saveXML">Exportar</b-button> -->
              </div>
              <b-row v-if="exporting" class="waitTxt rowDistance"
                >{{$t('exportingScenarioMessage')}}</b-row
              >
              <br />
            </b-col>
          </b-row>
          <b-row class="groupBtn">
            <img
              id="ExportScenario"
              class="float-right"
              src="@/assets/exportar.png"
              style="margin-left: 30px"
              :title="$t('exportScenarioButtom')"
              alt="Exportar cenário"
              @click="saveXML"
            />
            <img
              id="closeModalExportScenario"
              class="float-right"
              src="@/assets/sair.png"
              style="margin-left: 30px"
              :title="$t('exit')"
              alt="Sair"
              @click="$bvModal.hide('modalExportScenario')"
            />
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { urlMainAPI, showError, defaultSuccess } from "@/global";
// import axios from "axios";
import { mapState } from "vuex";
import { saveAs } from "file-saver";
// import axios from 'axios';

export default {
  name: "ExportScenario",
  data: function () {
    return {
      modelName: "",
      exporting: false,
    };
  },
  computed: mapState(["xml", "scenarioName"]),
  methods: {
    checkLocalStorage() {
      if (this.xml.scenario == "" && this.xml.scenarioResult == "") {
        showError(this.$t('nenhum-cenario-carregado'))
        return;
      }
      this.parseXMLResponse();
      // this.saveXML()
    },

    async saveXML() {
      this.exporting = true;
      // let xmlSend = ""
      this.modelName = this.modelName == "" ? "Nome" : this.modelName;
      
      let xmlScenario = new Blob([this.xml.scenario], {encoding:"UTF-8",type:"text/xml;charset=UTF-8"} );
      
      saveAs(xmlScenario, `${this.modelName} (${this.scenarioName}) - envio.xml`);
      defaultSuccess(this.$t('este-arquivo-foi-salvo-em-downloads'));

      this.exporting = false;
      this.$bvModal.hide("modalExportScenario");
    },

    parseXMLResponse() {
      console.log("Entrou parseXMLResponse");
      
      var xmlDoc = new DOMParser().parseFromString(
        this.xml.scenario,
        "application/xml",
      );

      console.log('xmlDoc:', xmlDoc)
      this.modelName = xmlDoc
        .getElementsByTagName("Simulation")[0]
        .getAttribute("diagram_name");
        
    },
  },
  created() {
    this.checkLocalStorage();
  },
};
</script>

<style scoped>
.exportContainer {
  max-width: 600px;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.waitTxt {
  justify-content: center;
  /* font-weight: bold; */
  background: black;
  color: white;
  margin-bottom: 10px;
}

.rowDistance {
  margin-top: 20px;
}

img {
  max-height: 35px;
}
</style>
